import { useState } from 'react';

const useToken = () => {
    const getToken = (): string | null => {
        try {
            const tokenString = localStorage.getItem('token');
            if (!tokenString) return null;
            const userToken = JSON.parse(tokenString);
            return userToken;
        } catch (e) {
            return null;
        }
    };

    const [token, setTokenState] = useState<string | null>(getToken());

    const saveToken = (userToken: string | null) => {
        if (userToken) {
            localStorage.setItem('token', JSON.stringify(userToken));
        } else {
            localStorage.removeItem('token');
        }
        setTokenState(userToken);
    };

    return {
        setToken: saveToken,
        token,
    };
};

export default useToken;
